// [ai] What every page shares: the query states (loading / a refused item shown with the server's words), rendered server HTML
// (trusted: the vault's own Markdown through app/lib/render), the page title into the shell (crumb + document.title).
import { useEffect } from "react";
import { useShellStore } from "../stores/shell";

export function Loading() { return <p className="at-hint at-loading" role="status">Loading…</p>; }
export function PageError({ error, title }: { error: Error; title?: string }) {
  return <section className="at-page"><p className="at-eyebrow">Astranote</p><h1>{title ?? "Unavailable"}</h1><p className="at-warn">{error.message}</p></section>;
}
/** Server-rendered HTML (a document fragment, a lede, an imported file's text). */
export function Html({ html, className, as: Tag = "div", ref }: { html: string; className?: string; as?: "div" | "article" | "span" | "section"; ref?: React.Ref<HTMLElement> }) { return <Tag ref={ref as React.Ref<HTMLDivElement>} className={className} dangerouslySetInnerHTML={{ __html: html }} />; }
/** The page names itself to the shell; cleared when it unmounts. */
export function usePageTitle(title: string | undefined) {
  const store = useShellStore();
  useEffect(() => { store.getState().setTitle(title ?? ""); return () => store.getState().setTitle(""); }, [store, title]);
}
export const n = (k: number, word: string) => `${k} ${word}${k === 1 ? "" : "s"}`;
